import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { MdDelete } from "react-icons/md";
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../component/b2b/navBar/b2bNavBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../css/custom-scrollbar.css';
import { LuWarehouse } from "react-icons/lu";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Base_Url, deletewarehouse, b2bWarehouseList } from '../../../config/config';
import B2bViewWarehouse from '../../../component/b2b/models/viewWarehouseModel';

const AllWarehouses = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const { isDarkMode } = useMyContext();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { isToggleSidebar } = useMyContext();
  const [warehouses, setWarehouses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [loadingWarehouseId, setloadingWarehouseId] = useState(null);
  const itemsPerPage = 8;
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    fetchWarehouses();
  }, [page, limit]);

  const fetchWarehouses = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    try {
      const pageNumber = Number(page) || 1;
      const limitNumber = Number(limit) || 10;
      const urlWarehouse = `${Base_Url}${b2bWarehouseList}?page=${pageNumber}&limit=${limitNumber}`
      const response = await fetch(urlWarehouse, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cusid,
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.status === "SUCCESS" && Array.isArray(result.data)) {
        setWarehouses(result.data);
        setTotalOrders(result.pagination.totalItems || 0);
      } else {
        console.error('Unexpected response format:', result);
      }
    } catch (error) {
      console.error('Error fetching warehouse data:', error);
    }
  };

  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = warehouses.slice(indexOfFirstItem, indexOfLastItem);

  const handleViewClick = (warehouse) => {
    setSelectedWarehouse(warehouse);
    setIsPopupOpen(true);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  // Function to update warehouse in the list
  const handleUpdateWarehouse = (updatedWarehouse) => {
    setWarehouses(prevWarehouses =>
      prevWarehouses.map(warehouse =>
        warehouse.id === updatedWarehouse.id ? updatedWarehouse : warehouse
      )
    );
  };

  const handleDelete = async (id) => {
    setloadingWarehouseId(id);

    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this deletion!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#000000',
      cancelButtonColor: '#666666',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const urldelete = Base_Url + deletewarehouse;
        try {
          const token = localStorage.getItem('token');
          const cusid = localStorage.getItem('cus_id');
          const data = { warehouseId: id };

          const response = await axios.post(urldelete, data, {
            headers: {
              token,
              cus_id: cusid,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });

          if (response.data.status === "SUCCESS") {
            setWarehouses((prevWarehouses) =>
              prevWarehouses.filter((warehouse) => warehouse.id !== id)
            );
            setTotalOrders((prev) => prev - 1);

            Swal.fire(
              'Deleted!',
              response.data.message || 'Warehouse has been deleted successfully.',
              'success'
            );
          } else {
            Swal.fire(
              'Error!',
              'Unexpected response format: ' + response.data.message,
              'error'
            );
          }
        } catch (error) {
          Swal.fire(
            'Error!',
            'Error deleting warehouse: ' + error.message,
            'error'
          );
        } finally {
          setloadingWarehouseId(null);
        }
      } else {
        setloadingWarehouseId(null);
      }
    });
  };
 const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
  return (
    <>
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'bg-black' : 'bg-white'}`}>
       <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />
          
                <NavBar />
          
                <div className="flex flex-1 overflow-hidden">
          
                  {isToggleSidebar && (
                    <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
                      <Sidebar />
                    </div>
                  )}

          <div className={`flex flex-1 flex-col min-h-0 overflow-hidden w-full p-3 ${isDarkMode ? 'bg-black' : 'bg-gray-100'}`}>
            {/* Header Button */}
            <button
              className={`text-[9px] font-semibold mb-2 flex-shrink-0 px-3 py-1.5 rounded flex items-center justify-center transition-colors w-fit
                ${isDarkMode
                  ? 'bg-white text-black hover:bg-gray-200'
                  : 'bg-slate-800 text-white hover:bg-gray-800'
                }`}>
              <LuWarehouse className="mr-1.5" size={13} />
              All Warehouses
            </button>

            {/* Table Container */}
            <div className="flex-1 min-h-0 overflow-hidden border rounded-lg" style={{ borderColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)' }}>
              <div className="h-full overflow-y-auto custom-scrollbar overflow-x-auto">
                <table className="min-w-full table-auto">
                  <thead className={`sticky top-0 text-[9px] bg-slate-800 uppercase tracking-wider z-10 text-white border-b border-white/20`}>
                    <tr>
                      <th className='px-2 py-2 text-left font-semibold'>ID</th>
                      <th className='px-2 py-2 text-left font-semibold'>Name</th>
                      <th className='px-2 py-2 text-left font-semibold'>Contact</th>
                      <th className='px-2 py-2 text-left font-semibold'>Phone</th>
                      <th className='px-2 py-2 text-left font-semibold'>City</th>
                      <th className='px-2 py-2 text-left font-semibold'>State</th>
                      <th className='px-2 py-2 text-left font-semibold'>Country</th>
                      <th className='px-2 py-2 text-center font-semibold'>Actions</th>
                    </tr>
                  </thead>
                  <tbody className={`divide-y ${isDarkMode ? 'divide-white/10' : 'divide-black/10'}`}>
                    {warehouses.length > 0 ? (
                      warehouses.map((warehouse, index) => (
                        <tr
                          key={warehouse.id}
                          className={`transition-colors duration-150 ${
                            isDarkMode 
                              ? 'bg-black hover:bg-white/5 text-white' 
                              : 'bg-white hover:bg-gray-50 text-black'
                          }`}
                        >
                          <td className='px-2 py-2 text-[10px] font-mono'>
                            #{warehouse.warehouse_id}
                          </td>
                          <td className='px-2 py-2 text-[10px] font-medium'>{warehouse.name}</td>
                          <td className='px-2 py-2 text-[10px]'>{warehouse.contact_person}</td>
                          <td className='px-2 py-2 text-[10px] font-mono'>{warehouse.phone_number}</td>
                          <td className='px-2 py-2 text-[10px]'>{warehouse.city}</td>
                          <td className='px-2 py-2 text-[10px]'>{warehouse.state}</td>
                          <td className='px-2 py-2 text-[10px]'>{warehouse.country}</td>
                          <td className='px-2 py-2'>
                            <div className='flex items-center justify-center gap-1.5'>
                              <button
                                onClick={() => handleViewClick(warehouse)}
                                className={`p-1 rounded transition-colors border ${
                                  isDarkMode 
                                    ? 'border-white/20 hover:bg-white/10' 
                                    : 'border-black/20 hover:bg-black/10'
                                }`}
                              >
                                <IoMdEye size={14} className={isDarkMode ? 'text-white' : 'text-black'} />
                              </button>

                              <button
                                onClick={() => handleDelete(warehouse.id)}
                                disabled={loadingWarehouseId === warehouse.id}
                                className={`p-1 rounded transition-colors border ${
                                  isDarkMode 
                                    ? 'border-white/20 hover:bg-white/10' 
                                    : 'border-black/20 hover:bg-black/10'
                                } ${loadingWarehouseId === warehouse.id ? 'opacity-50 cursor-not-allowed' : ''}`}
                              >
                                {loadingWarehouseId === warehouse.id ? (
                                  <svg className="animate-spin h-3.5 w-3.5" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                  </svg>
                                ) : (
                                  <MdDelete size={14} className={isDarkMode ? 'text-white' : 'text-black'} />
                                )}
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className={`text-center py-6 text-[11px] ${isDarkMode ? 'text-white/50' : 'text-black/50'}`}>
                          No warehouses found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Footer - Pagination & Controls */}
            <div className="mt-2 flex-shrink-0 flex flex-col sm:flex-row justify-between items-center gap-2">
              <span className={`text-[9px] font-medium ${isDarkMode ? 'text-white/70' : 'text-black/70'}`}>
                Total: <span className="font-bold">{totalOrders}</span>
              </span>
              
              <div className="flex items-center gap-2">
                <div className="flex items-center gap-1.5">
                  <span className={`text-[8px] ${isDarkMode ? 'text-white/50' : 'text-black/50'}`}>Show</span>
                  <select
                    id="limit"
                    value={limit}
                    onChange={handleLimitChange}
                    className={`border rounded px-1.5 py-0.5 text-[9px] focus:outline-none focus:ring-1 ${
                      isDarkMode 
                        ? 'bg-black text-white border-white/30 focus:ring-white/50' 
                        : 'bg-white text-black border-black/30 focus:ring-black/50'
                    }`}
                  >
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={totalOrders}>All</option>
                  </select>
                </div>

                <Pagination
                  count={Math.ceil(totalOrders / limit)}
                  page={page}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  className="pagination"
                  size="small"
                  renderItem={(item) => (
                    <PaginationItem
                      {...item}
                      className="mx-0.5 rounded"
                      style={{
                        color: isDarkMode ? '#ffffff' : '#000000',
                        borderColor: isDarkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                        backgroundColor: item.selected ? (isDarkMode ? '#ffffff' : '#000000') : 'transparent',
                        ...(item.selected ? { color: isDarkMode ? '#000000' : '#ffffff' } : {}),
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
        <B2bViewWarehouse 
          isopen={isPopupOpen} 
          onClose={handleClose} 
          warehouse={selectedWarehouse}
          onUpdate={handleUpdateWarehouse}
        />
      </div>
    </>
  );
};

export default AllWarehouses;